<template>
  <div :class="name">
    <div :class="`${name}-previewTitle`">{{ $t('module_library_native_preview_post') }}</div>
    <div :class="`${name}-previewContent`">
      <!-- 视频预览 -->
      <div :class="`${name}-previewWrapper`">
        <img :src="authorizationRight" class="authorizationRight unifyStyle" alt="" />
        <img :src="avatar.url" class="userAvatar unifyStyle" alt="" />
        <img :src="ttPreviewPlus" class="authorizationPlus unifyStyle" />
        <ttPreviewTopbar class="authorizationTop unifyStyle" />

        <div class="contextInfo unifyStyle">
          <div v-if="anchorPointTitle !== ''" class="anchorContainer">
            <img class="anchorImg" :src="authorizationShop" alt="" />
            <div class="anchorText">{{ anchorPointTitle }}</div>
          </div>

          <div class="name">@{{ nativeVideo.nickName }}</div>
          <div class="labelContainer">
            <span class="label">{{ nativeVideo.text }}</span>
            <span class="adTag">{{ $t('ad_preview_sponsored') }}</span>
          </div>

          <div class="music">
            <ttMusicTag class="musicIcon" />
            <span>{{ $t('ad_preview_promotional_music') }}</span>
          </div>

          <div class="moreAction">
            <i class="vi-icon2-arrowright" />
          </div>
        </div>

        <div class="bottomBanner">
          <img class="img" :src="ttPreviewNavBar" alt="" />
        </div>

        <div class="videoPreview">
          <video-player
            ref="creativeVideoPreview"
            :src="videoInfo.playUrl"
            :poster="videoInfo.coverUrl"
            :show-control="false"
            :autoplay="false"
            :active="true"
          />
        </div>
      </div>

      <!-- 账号视频信息 -->
      <div :class="`${name}-videoSummary`">
        <div class="summaryAvatar">
          <img :src="avatar.url" alt="" />
        </div>
        <div class="summaryText">
          <div class="nickNameText">
            <overflow-tooltip :label="nativeVideo.nickName" placement="top" effect="light" />
          </div>
          <div class="itemIdText">
            <overflow-tooltip :label="`ID: ${nativeVideo.coreUserId}`" placement="top" effect="light" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, defineComponent, toRefs } from '@vue/composition-api';
import { get } from 'lodash-es';
import { bitrateFormatter, bytesToSize } from '@tt4b/ttam-utils';
import VideoPlayer from '@/components/common/video-player/index.vue';
import authorizationRight from '@tt4b/ttam-assets/src/images/creative/authorization-right.png';
import ttPreviewPlus from '@tt4b/ttam-assets/src/images/creative/tt-preview-plus.png';
import ttPreviewTopbar from '@tt4b/ttam-assets/src/images/creative/tt-preview-topbar.svg';
import authorizationShop from '@tt4b/ttam-assets/src/images/creative/authorization-shop.png';
import ttMusicTag from '@tt4b/ttam-assets/src/images/creative/tt-music-tag.svg';
import ttPreviewNavBar from '@tt4b/ttam-assets/src/images/creative/tt-preview-nav-bar.jpg';
const name = 'ttam-identity-tiktok-post-authorization-video-detail';
export default defineComponent({
  name,
  components: {
    VideoPlayer,
    ttMusicTag,
    ttPreviewTopbar,
  },
  props: {
    nativeVideo: {
      type: Object,
      required: true,
    },
    videoCode: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { nativeVideo } = toRefs(props);
    const videoInfo = computed(() => {
      let info = nativeVideo.value.videoInfo || {};
      return {
        ...info,
        src: info.playUrl,
        poster: info.coverUrl,
      };
    });
    const avatar = computed(() => nativeVideo.value.avatarIcon || {});
    const anchorPointTitle = computed(() => get(nativeVideo.value, 'anchors[0].title', ''));
    const duration = function (time) {
      const intTime = Math.round(time);
      const minute = intTime / 60 > 1 ? `${parseInt(intTime / 60, 10)} min ` : '';
      const second = `${intTime % 60} s`;

      return `${minute}${second}`;
    };
    const bytes = function (value) {
      return bytesToSize(value);
    };
    const bitrate = function (value) {
      return bitrateFormatter(value);
    };
    return {
      name,
      authorizationRight,
      ttPreviewPlus,
      ttPreviewTopbar,
      authorizationShop,
      ttMusicTag,
      ttPreviewNavBar,
      videoInfo,
      avatar,
      anchorPointTitle,
      duration,
      bytes,
      bitrate,
    };
  },
});
</script>

<style lang="scss">
$name: 'ttam-identity-tiktok-post-authorization-video-detail';
.#{$name} {
  margin: auto;
  padding: 16px;
  width: 250px;
  height: 500px;
  background: $--color-group3-9;
  &-previewTitle {
    padding-bottom: 8px;
    font-weight: $font-weight-bold;
    line-height: 22px;
  }
  &-previewContent {
    width: 218px;
    height: 388px;
    background: $--color-group3-9;
    border-radius: 4px;
  }

  &-previewWrapper {
    position: relative;
    width: 218px;
    height: 388px;
    overflow: hidden;
    border-radius: 4px;

    .unifyStyle {
      position: absolute;
      z-index: 999;
      color: $--color-group3-10;
    }

    .authorizationRight {
      right: 5px;
      bottom: 37px;
      width: 44px;
      height: auto;
    }

    .userAvatar {
      right: 5px;
      bottom: 230px;
      width: 28px;
      height: 28px;
      border-radius: 28px;
    }

    .authorizationPlus {
      right: 12px;
      bottom: 222px;
      z-index: 1000;
      width: 14px;
      height: 14px;
    }

    .authorizationTop {
      top: 8px;
      left: 50%;
      width: 100px;
      transform: translateX(-50%);
    }

    .contextInfo {
      position: absolute;
      bottom: 38px;
      left: 6px;
      width: 156px;

      .anchorContainer {
        display: flex;
        align-items: center;
        max-width: 120px;
        margin-bottom: 3px;
        padding: 4px;
        background: rgba(37, 37, 37, 0.6);
        border-radius: 4px;

        .anchorImg {
          width: 12px;
          height: 12px;
        }

        .anchorText {
          max-width: 80%;
          font-size: 12px;
          font-weight: $font-weight-bold;
          line-height: 12px;
          @include text-ellipse();
          transform: translateY(0) scale(0.75);
        }
      }

      .name {
        transform: translateX(-14px) scale(0.8);
      }

      .labelContainer {
        position: relative;
        display: -webkit-box;
        margin-right: 6px;
        overflow: hidden;
        line-height: 16px;
        text-overflow: ellipsis;
        overflow-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        transform: translateX(-18px) scale(0.75);
      }

      .adTag {
        display: inline-block;
        margin-left: 2px;
        padding: 2px 4px;
        color: rgba(0, 0, 0, 0.75);
        font-weight: $font-weight-bold;
        font-size: 12px;
        line-height: 12px;
        background: rgba(255, 255, 255, 0.75);
        border-radius: 3px;
        transform: scale(0.5);
        transform-origin: left;
      }

      .music {
        display: flex;
        align-items: center;
        padding-bottom: 4px;
        transform: translateX(-18px) scale(0.75);

        .musicIcon {
          width: 10px;
          height: 10px;
          margin-right: 4px;
        }
      }

      .moreAction {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 150px;
        height: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        background: #3a3a3a;
        border-radius: 4px;
        opacity: 0.5;

        span {
          transform: scale(0.75);
        }
      }
    }

    .bottomBanner {
      position: absolute;
      bottom: 0;
      z-index: 1;
      .img {
        display: block;
        width: 100%;
      }
    }

    .videoPreview {
      width: 218px;
      height: 360px;
    }
  }

  &-videoSummary {
    display: flex;
    padding-top: 12px;

    .summaryAvatar {
      width: 40px;
      height: 40px;
      border-radius: 40px;
      overflow: hidden;
      img {
        width: 40px;
        height: 40px;
      }
    }

    .summaryText {
      padding-left: 12px;
      .nickNameText {
        line-height: 22px;
        width: 140px;
        @include text-ellipse();
      }
      .itemIdText {
        font-size: 12px;
        line-height: 20px;
        color: $--color-group3-2;
        width: 160px;
      }
    }
  }
}
</style>
